import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import CaseNoteModal from './CaseNoteModal';
import { useDisclose } from '../../../Modal/Hooks/useDisclose';

interface Props {
	className?: string;
	note?: {
		id: string;
		text: string;
	};
	caseId: string;
	onSuccess?: () => void;
	firstUpper?: boolean;
}
const CaseNoteButton: React.FC<Props> = ({
	note,
	className,
	caseId,
	onSuccess,
	firstUpper = false,
}) => {
	const { isOpen, onClose, onOpen } = useDisclose(false);

	const handleOnSuccess = () => {
		onSuccess?.();
		onClose();
	};

	return (
		<>
			<LinkButton
				title={note ? 'base.shared.editNote' : 'base.shared.addNote'}
				theme={Theme.BLUE}
				onClick={onOpen}
				className={className}
				firstUpper={firstUpper}
			/>
			{isOpen && (
				<CaseNoteModal
					isOpen
					onClose={onClose}
					note={note}
					caseId={caseId}
					onSuccess={handleOnSuccess}
				/>
			)}
		</>
	);
};

export default CaseNoteButton;
